package org.hs_soft.runmynesto.domain.usecase.options.cash_register_config

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_cash_register.CreateCashRegisterModel
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_shop.CreateNewShopModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateCashRegisterRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewShopRepository


class CreateCashRegisterUseCase(
    private val repository: CreateCashRegisterRepository
) {
    suspend operator fun invoke(
        deviceType:String,
        name:String,
        shopId:String,
        hardwareId:String,
        settingsCopyId:String,
        deactivateAllContent:Boolean,
    ): CreateCashRegisterModel {
        return repository.createCashRegister(
            name=name,
            deviceType = deviceType,
            shopId = shopId,
            hardwareId = hardwareId,
            settingsCopyId = settingsCopyId,
            deactivateAllContent=deactivateAllContent,
        )
    }

    fun cancel(){
        repository.cancel()
    }
}